module.exports = __webpack_public_path__ + "img/图片26.1890f8ea.png";